import React, { useState, useEffect, useRef, useMemo } from "react";
import Sidebar from "../../composant_reutilisable/sidebar";
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from "../../composant_reutilisable/useAuth";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Dropdown, Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import axios from 'axios';
import Pas_acces from "../../composant_reutilisable/pas_acces";
import { Accordion } from "react-bootstrap";

import {
  FaPlus,
  FaShieldAlt,
  FaTrash,
  FaEdit,
  FaSortAmountUp,
  FaSortAmountDown,
  FaArrowLeft,
  FaArrowRight,
  FaChevronDown,
  FaMapMarkerAlt,
  FaSync,
  FaGlobe,
  FaHandshake,
  FaSearch,
  FaCheckCircle,
  FaTruck,
  FaCaretDown,
  FaWindowClose,
  FaDotCircle,
  FaEllipsisV,
  FaBoxes,
  FaPlusCircle,
  FaInfoCircle,
  FaCogs,
  FaSave,
  FaExclamationCircle,
  FaChevronUp,
  FaExclamationTriangle,
  FaQuestionCircle,
  FaDesktop,
  FaRedo,
  FaMoneyBill,
} from "react-icons/fa";
import FedaPayButton from "../../composant_reutilisable/FedaPayButton";

const Liste_declaration_fret = ({ titre }) => {
  useAuth();
  const location = useLocation();
  const user_id = localStorage.getItem("userId");
  const navigate = useNavigate();
  const { parcRef } = location.state || {};

  // État pour les données et la gestion de la table
  const [frets, setFrets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [alertModal, setAlertModal] = useState({ message: "", type: "" });
  const [totalItems, setTotalItems] = useState(0);
  const [showInfo, setShowInfo] = useState(true);
  const accesGroupe = JSON.parse(localStorage.getItem('accesGroupe')) || [];
  const [fretSelectionne, setFretSelectionne] = useState(null);

  const [userData, setUserData] = useState({});

  const fetchUserData = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`);
      if (!response.ok) throw new Error('Erreur réseau');
      const data = await response.json();
      setUserData(data);
    } catch (error) {
      console.error('Erreur réseau:', error);
    }
  };
  useEffect(() => {
    fetchUserData();
  }, [user_id]);

  const showAlert = (message, type = "success") => {
    setAlert({ message, type });
    // setTimeout(() => {
    //   setAlert({ message: "", type: "" });
    // }, 3000);
  };

  const showAlertModal = (message, type = "success") => {
    setAlertModal({ message, type });
  };

  const fermerNotif = () => {
    setAlert({ message: "", type: "" });
    setAlertModal({ message: "", type: "" });
  };

  useEffect(() => {
    if (user_id) {
      document.title = "Transportpro | Gestion des fret";
    }
  }, [user_id]);


  const fetchData = async () => {
    try {
      let url;
      if (accesGroupe.includes('Administration')) {
        url = `${process.env.REACT_APP_HOTE}/liste-frets-complet/?page=${currentPage}&per_page=${itemsPerPage}&parcRef=${parcRef || userData?.parc}`;
      } else {
        url = `${process.env.REACT_APP_HOTE}/liste-frets/${user_id}/?page=${currentPage}&per_page=${itemsPerPage}&parcRef=${parcRef || userData?.parc}`;
      }

      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const data = await response.json();
        setFrets(data.frets);
        setTotalItems(data.pagination.total);
      }
      setLoading(false);
    } catch (error) {
      console.error("Erreur lors du chargement des frets:", error);
      setLoading(false);
    }
  };



  const [parcs, setParcs] = useState([]);
  // Récupération des parcs
  const fetchParcs = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + "/liste-parc/");
      if (response.ok) {
        const data = await response.json();
        setParcs(data);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des parcs:", error);
    }
  };



  const fetchFrets = async (forceRefresh = false) => {
    try {
      setLoading(true);

      let url;
      if (accesGroupe.includes('Administration')) {
        url = `${process.env.REACT_APP_HOTE}/liste-frets-complet/?page=${currentPage}&per_page=${itemsPerPage}&parcRef=${parcRef || userData?.parc}`;
      } else {
        url = `${process.env.REACT_APP_HOTE}/liste-frets/${user_id}/?page=${currentPage}&per_page=${itemsPerPage}&parcRef=${parcRef || userData?.parc}`;
      }


      // url = `${process.env.REACT_APP_HOTE}/liste-frets-complet/?page=${currentPage}&per_page=${itemsPerPage}`;

      // Pour éviter le cache, ajoutez un timestamp au lieu d'utiliser des en-têtes personnalisés
      if (forceRefresh) {
        url += `&_=${new Date().getTime()}`;
      }

      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        setFrets(data.frets);
        setTotalItems(data.pagination.total);
        if (forceRefresh) {
          setCurrentPage(1);
          handleAssignationAutomatique()
          showAlert('Données actualisées avec succès', 'success');
        }
      }
    } catch (error) {
      console.error("Erreur lors du chargement des frets:", error);
      showAlert("Erreur lors de l'actualisation des données", "danger");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchData();
    fetchParcs();
  }, [currentPage, itemsPerPage]);

  // Fonction de tri
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
    fetchData(true);
  };

  const fretsFiltres = frets.filter(fret =>
    fret?.ref?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    fret?.nature_fret?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    fret?.type_fret?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    fret?.bailleur?.nom?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    fret?.nom_destinataire?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    fret?.ville_depart?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    fret?.ville_arrivee?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    fret?.statut?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    fret?.charge_utile_totale?.toString().includes(searchTerm) ||
    fret?.charge_restante?.toString().includes(searchTerm) ||
    (fret?.utilisateur?.nom + ' ' + fret?.utilisateur?.prenoms)?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // const handleSort = (key) => {
  //   const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
  //   setSortConfig({ key, direction });
  //   setCurrentPage(1);
  //   fetchData(true); // Force le rechargement
  // };
  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const fretsTries = [...fretsFiltres].sort((a, b) => {
    if (sortConfig.key) {
      // Gestion spéciale pour les champs imbriqués
      let valueA, valueB;

      if (sortConfig.key === 'bailleur') {
        valueA = a.bailleur?.nom?.toString().toLowerCase() || "";
        valueB = b.bailleur?.nom?.toString().toLowerCase() || "";
      } else if (sortConfig.key === 'utilisateur') {
        valueA = (a.utilisateur?.nom + ' ' + a.utilisateur?.prenoms)?.toString().toLowerCase() || "";
        valueB = (b.utilisateur?.nom + ' ' + b.utilisateur?.prenoms)?.toString().toLowerCase() || "";
      } else {
        valueA = a[sortConfig.key]?.toString().toLowerCase() || "";
        valueB = b[sortConfig.key]?.toString().toLowerCase() || "";
      }

      if (valueA < valueB) return sortConfig.direction === "ascending" ? -1 : 1;
      if (valueA > valueB) return sortConfig.direction === "ascending" ? 1 : -1;
    }
    return 0;
  });

  // Gestion du changement d'éléments par page
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Réinitialiser à la première page
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = fretsTries.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(fretsFiltres.length / itemsPerPage);

  // Changer de page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Formater la date pour l'affichage
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };


  // États nécessaires
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fretToDelete, setFretToDelete] = useState(null);

  // Fonction de suppression
  const handleDeleteFret = async () => {
    if (!fretToDelete) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-fret/${fretToDelete.id}/${user_id}/`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        // Mettre à jour l'état local
        setFrets(frets.filter(f => f.id !== fretToDelete.id));
        showAlert('Fret supprimé avec succès', 'success');
      } else {
        const error = await response.json();
        showAlert(error.message || 'Erreur lors de la suppression', 'error');
      }
    } catch (error) {
      showAlert('Erreur réseau', 'error');
      console.error(error);
    } finally {
      setShowDeleteModal(false);
      setFretToDelete(null);
    }
  };



  const assignerCamionsAuFret = async (fretId) => {
    try {
      setLoading(true);

      let data;
      let response;

      if (fretToAssign?.types_camions.length > 0) {
        response = await fetch(
          `${process.env.REACT_APP_HOTE}/assigner-camions-au-fret-avec-charge/${fretId}/${user_id}/`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
      } else {
        response = await fetch(
          `${process.env.REACT_APP_HOTE}/assigner-camions-au-fret/${fretId}/${user_id}/`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
      }

      data = await response.json();

      if (!response.ok) {
        showAlert(data.error || "Erreur lors de l'assignation", 'danger');
        return;
      }

      // Afficher uniquement les nouveaux camions assignés
      const { details = {} } = data;
      const { assignations = [] } = details;

      if (assignations.length === 0) {
        showAlert("Aucun camion assigné", 'info');
      } else {
        let message = `
        <strong>Camions assignés :</strong>
        <ul style="margin-top: 8px; padding-left: 20px;">
          ${assignations.map(c => `<li>${c.immatriculation || 'N/A'}</li>`).join('')}
        </ul>
      `;
        showAlert(message, 'success');
      }

      await fetchData();
      setShowAssignModal(false);

    } catch (error) {
      console.error("Erreur:", error);
      showAlert("Erreur réseau - Impossible de contacter le serveur", 'error');
    } finally {
      setLoading(false);
    }
  };





  const [openDropdownId, setOpenDropdownId] = useState(null);
  const dropdownRef = useRef(null);

  const toggleDropdown = (id) => {
    setOpenDropdownId((prevId) => (prevId === id ? null : id));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownItemStyle = {
    padding: '8px 12px',
    width: '100%',
    textAlign: 'left',
    border: 'none',
    background: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  };

  const [showAuthorizationModal, setShowAuthorizationModal] = useState(false);
  const [fretAuthoriser, setFretAuthoriser] = useState(null);
  const [authoriserMessage, setAuthoriserMessage] = useState('');
  const [autorisationChoix, setAutorisationChoix] = useState('oui');
  const [sourceApprovisionnement, setSourceApprovisionnement] = useState('nationaux');

  const handleOuvrirAutorisationModal = (fret) => {
    setFretAuthoriser(fret);

    // Construire le message détaillé
    const message = `
      <div>
        <p>Souhaitez-vous autoriser l'utilisation de camions d'autres appartenances pour compléter ?</p>
      </div>
    `;

    setAuthoriserMessage(message);
    setShowAuthorizationModal(true);
  };



  const confirmAuthorization = async () => {
    if (!fretAuthoriser) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/autoriser/${fretAuthoriser.id}/${user_id}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          autorise: autorisationChoix,
          source_approvisionnement: autorisationChoix === 'oui' ? sourceApprovisionnement : ''
        })
      });

      if (response.ok) {
        // Mettre à jour l'état local
        setFrets(frets.map(f =>
          f.id === fretAuthoriser.id ? { ...f, autorise: autorisationChoix } : f
        ));

        showAlert(`Autorisation "${autorisationChoix}" enregistrée avec succès`, 'success');

        // Si "oui", on peut tenter d'assigner les camions
        // await assignerCamionsAuFret(fretAuthoriser.id);
      } else {
        const error = await response.json();
        showAlert(error.message || "Erreur lors de l'autorisation", 'error');
      }
    } catch (error) {
      showAlert('Erreur réseau', 'error');
      console.error(error);
    } finally {
      setShowAuthorizationModal(false);
      setFretAuthoriser(null);
      setAutorisationChoix('oui'); // Réinitialiser le choix
    }
  };

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [fretToAssign, setFretToAssign] = useState(null);

  const handleAnnulerAssignation = async (fretId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/annuler-assignation-fret/${fretId}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const data = await response.json();
      if (response.ok) {
        showAlert(data.success);
        fetchData()
      } else {
        showAlert(data.error, 'danger');
      }
    } catch (error) {
      console.error('Erreur lors de l\'annulation');
    } finally {
      fetchData()
    }
    toggleDropdown(null);
  };

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedFretDetails, setSelectedFretDetails] = useState(null);

  const handleShowDetails = (fret) => {
    setSelectedFretDetails(fret);
    setShowDetailsModal(true);
  };


  const [showSpecQuotaModal, setShowSpecQuotaModal] = useState(false);
  const [activeTab, setActiveTab] = useState('spec');

  const handleOpenSpecQuotaModal = (fret) => {
    setFretSelectionne(fret);

    // Initialiser formData avec les données existantes du fret
    const initialFormData = {
      types_camions: fret.types_camions.map(t => t.id),
      nbre_type: {},
      charge_utile_par_type: {},
      quota_nationaux: {},
      quota_pays_destination: {},
      quota_bailleur: {},
      charge_utile_totale: fret.charge_utile_totale || 0
    };

    // Remplir les données pour chaque type de camion
    fret.types_camions.forEach(type => {
      const typeId = type.id.toString();

      // Calculer le nombre total de camions pour ce type
      const totalCamions =
        (fret.quotas.nationaux[typeId]?.valeur || 0) +
        (fret.quotas.pays_destination[typeId]?.valeur || 0) +
        (fret.quotas.bailleur[typeId]?.valeur || 0);

      initialFormData.nbre_type[typeId] = totalCamions;
      initialFormData.charge_utile_par_type[typeId] =
        fret.quotas.nationaux[typeId]?.charge_utile_par_camion ||
        fret.quotas.pays_destination[typeId]?.charge_utile_par_camion ||
        fret.quotas.bailleur[typeId]?.charge_utile_par_camion || 0;

      initialFormData.quota_nationaux[typeId] = fret.quotas.nationaux[typeId]?.valeur || 0;
      initialFormData.quota_pays_destination[typeId] = fret.quotas.pays_destination[typeId]?.valeur || 0;
      initialFormData.quota_bailleur[typeId] = fret.quotas.bailleur[typeId]?.valeur || 0;
    });

    setFormData(initialFormData);
    setShowSpecQuotaModal(true);
    setActiveTab('spec');
  };



  const [formData, setFormData] = useState({
    // Spécificités
    types_camions: [],

    // nbre type
    nbre_type: {},

    // charge utile
    charge_utile_totale: 0,
    charge_utile_par_type: {},

    // Quotas
    quota_nationaux: {},
    quota_pays_destination: {},
    quota_bailleur: {},

  });

  const [typesCamions, setTypesCamions] = useState([]);

  // const handleTypesCamionsChange = (selectedOptions) => {
  //   const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];

  //   // Créer un nouvel objet nbre_type avec les nouveaux types
  //   const newNbreType = {};
  //   selectedValues.forEach(typeId => {
  //     if (!formData.nbre_type[typeId]) {
  //       newNbreType[typeId] = 0;
  //     } else {
  //       newNbreType[typeId] = formData.nbre_type[typeId];
  //     }
  //   });

  //   setFormData(prev => ({
  //     ...prev,
  //     types_camions: selectedValues,
  //     nbre_type: newNbreType,
  //     quota_nationaux: {},
  //     quota_pays_destination: {},
  //     quota_bailleur: {}
  //   }));
  // };


  const handleTypesCamionsChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];

    // Créer un nouvel objet nbre_type avec les nouveaux types
    const newNbreType = {};
    const newQuotaNationaux = { ...formData.quota_nationaux };
    const newQuotaPaysDestination = { ...formData.quota_pays_destination };
    const newQuotaBailleur = { ...formData.quota_bailleur };

    selectedValues.forEach(typeId => {
      if (!formData.nbre_type[typeId]) {
        newNbreType[typeId] = 0;
        if (!newQuotaNationaux[typeId]) newQuotaNationaux[typeId] = 0;
        if (!newQuotaPaysDestination[typeId]) newQuotaPaysDestination[typeId] = 0;
        if (!newQuotaBailleur[typeId]) newQuotaBailleur[typeId] = 0;
      } else {
        newNbreType[typeId] = formData.nbre_type[typeId];
      }
    });

    // Supprimer les quotas des types qui ne sont plus sélectionnés ET qui sont vides ou nuls
    Object.keys(newQuotaNationaux).forEach(typeId => {
      if (!selectedValues.includes(typeId) && !newQuotaNationaux[typeId]) {
        delete newQuotaNationaux[typeId];
      }
    });
    Object.keys(newQuotaPaysDestination).forEach(typeId => {
      if (!selectedValues.includes(typeId) && !newQuotaPaysDestination[typeId]) {
        delete newQuotaPaysDestination[typeId];
      }
    });
    Object.keys(newQuotaBailleur).forEach(typeId => {
      if (!selectedValues.includes(typeId) && !newQuotaBailleur[typeId]) {
        delete newQuotaBailleur[typeId];
      }
    });


    setFormData(prev => ({
      ...prev,
      types_camions: selectedValues,
      nbre_type: newNbreType,
      quota_nationaux: newQuotaNationaux,
      quota_pays_destination: newQuotaPaysDestination,
      quota_bailleur: newQuotaBailleur
    }));
  };

  const handleQuotaChange = (quotaType, camionType, value) => {
    setFormData(prev => ({
      ...prev,
      [quotaType]: {
        ...prev[quotaType],
        [camionType]: value ? parseInt(value) : 0
      }
    }));
  };

  const handleChargeUtileChange = (typeId, value) => {
    const chargeUtile = parseFloat(value) || 0;

    setFormData(prev => ({
      ...prev,
      charge_utile_par_type: {
        ...prev.charge_utile_par_type,
        [typeId]: chargeUtile
      }
    }));
  };

  const handleNbreTypeChange = (typeId, value) => {
    const nbreCamions = value ? parseInt(value) : 0;

    if (fretSelectionne?.type_fret === 'national') {
      setFormData(prev => ({
        ...prev,
        nbre_type: {
          ...prev.nbre_type,
          [typeId]: nbreCamions
        },
        quota_nationaux: {
          ...prev.quota_nationaux,
          [typeId]: nbreCamions
        },
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        nbre_type: {
          ...prev.nbre_type,
          [typeId]: nbreCamions
        }
      }));

    }
  };




  const [parametres, setParametres] = useState({
    emailAdmin: "",
    emailsCopie: [""],
    typeCamion: [],
    joursAvantEcheance: {
      niveau1: 30,
      niveau2: 15,
      niveau3: 7
    },
    nombre_elements_par_page: 5,
    duree_affichage_page: 5,
    marge_charge_utile: 5
  });

  // Fonction pour récupérer les paramètres depuis le back-end
  const recupererParametres = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/info-parametres-notifications/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setParametres({
          emailAdmin: data.data.email_admin || "Non_defini",
          emailsCopie: data.data.emails_copie?.length > 0
            ? data.data.emails_copie
            : ["email@exemple.com"],
          typeCamion: data.data.type_camion || [], // Charger les types de camions
          joursAvantEcheance: {
            niveau1: data.data.jours_avant_echeance?.niveau1 || 30,
            niveau2: data.data.jours_avant_echeance?.niveau2 || 15,
            niveau3: data.data.jours_avant_echeance?.niveau3 || 7
          },
          nombre_elements_par_page: data.data.nombre_elements_par_page || 5,
          duree_affichage_page: data.data.duree_affichage_page || 5,
          marge_charge_utile: data.data.marge_charge_utile || 0,
        });
      } else {
        setParametres(prev => ({
          ...prev,
          emailsCopie: ["exemple@domaine.com"]
        }));
        showAlert(data.message || "Erreur lors de la récupération des paramètres", 'danger');
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
      setParametres(prev => ({
        ...prev,
        emailsCopie: ["exemple@domaine.com"]
      }));
      showAlert("Erreur de connexion au serveur", 'danger');
    }
  };

  const fetchTypesCamions = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + "/liste-types/");
      if (response.ok) {
        const data = await response.json();

        let filteredTypes;

        // Vérification plus robuste de la valeur conteneurisée
        const isConteneurise = fretSelectionne?.conteneurise === 'Oui';

        // if (isConteneurise) {
        //   // Vérifier que parametres.typeCamion est bien un tableau
        //   const typesConteneurises = Array.isArray(parametres.typeCamion)
        //     ? parametres.typeCamion
        //     : [];

        //   filteredTypes = data
        //     .filter(type => typesConteneurises.includes(type.id))
        //     .map(type => ({
        //       value: type.id,
        //       label: type.libelle
        //     }));
        // } else {
        //   filteredTypes = data
        //     .filter(type => type.option !== 'Tete')
        //     .map(type => ({
        //       value: type.id,
        //       label: type.libelle
        //     }));
        // }


        filteredTypes = data
          .filter(type => type.option !== 'Tete')
          .map(type => ({
            value: type.id,
            label: type.libelle
          }));

        setTypesCamions(filteredTypes);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des types de camions:", error);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await recupererParametres();
      await fetchTypesCamions();
      // if (fretSelectionne) {
      //   await fetchTypesCamions();
      // }
    };

    loadData();
  }, [user_id]); // Déclenche quand conteneurise change



  const handleRenoncerCamion = async (camion) => {
    if (!camion) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/annuler-assignation-camion/${camion.id}/${user_id}/`,
        {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        showAlert(data.success || "Camion désassigné avec succès !");
        setShowDetailsModal(false);
        fetchData();
      } else {
        showAlertModal(data.error || "Erreur lors de la désassignation du camion", 'danger');
        console.error("Erreur:", data);
      }
    } catch (error) {
      console.error("Erreur réseau:", error);
      showAlertModal("Une erreur réseau est survenue", 'danger');
    }
  };



  const handleAssignationAutomatique = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_HOTE}/verifier_et_assigner_frets/${user_id}/`);
      if (response.ok) {
        fetchData()
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
    }
  };


  const reserverTransport = async () => {
    try {
      // Vérification des charges utiles
      const hasInvalidChargeUtile = formData.types_camions.some(typeId => {
        const chargeUtile = formData.charge_utile_par_type[typeId];
        return !chargeUtile || chargeUtile <= 0;
      });

      if (hasInvalidChargeUtile) {
        showAlertModal("La charge utile doit être supérieure à 0 pour tous les types de camions", "danger");
        return;
      }

      // Vérification du nombre de camions
      const hasInvalidCamionCount = formData.types_camions.some(typeId => {
        const nbreCamions = formData.nbre_type[typeId];
        return !nbreCamions || nbreCamions <= 0;
      });

      if (hasInvalidCamionCount) {
        showAlertModal("Le nombre de camions doit être supérieur à 0 pour tous les types", "danger");
        return;
      }

      // Vérification des quotas pour les frets internationaux
      if (fretSelectionne?.type_fret !== 'national') {
        const hasInvalidQuotas = formData.types_camions.some(typeId => {
          const totalQuotas =
            (formData.quota_nationaux[typeId] || 0) +
            (formData.quota_pays_destination[typeId] || 0) +
            (formData.quota_bailleur[typeId] || 0);

          return totalQuotas !== formData.nbre_type[typeId];
        });

        if (hasInvalidQuotas) {
          showAlertModal("La somme des quotas doit être égale au nombre total de camions pour chaque type", "danger");
          return;
        }
      }

      // Calculer la charge utile totale (au cas où elle n'a pas été calculée automatiquement)
      const calculatedTotal = formData.types_camions.reduce(
        (sum, typeId) => sum + (formData.charge_utile_par_type[typeId] || 0), 0
      );

      // Préparer les données pour l'envoi
      const requestData = {
        fret_id: fretSelectionne.id,
        types_camions: formData.types_camions,
        charge_utile_totale: calculatedTotal,
        charge_utile_par_type: formData.charge_utile_par_type,
        nbre_type: formData.nbre_type,
        quotas: {
          nationaux: formData.quota_nationaux,
          pays_destination: formData.quota_pays_destination,
          bailleur: formData.quota_bailleur
        }
      };

      const response = await fetch(`${process.env.REACT_APP_HOTE}/reserver-transport/${user_id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(requestData)
      });

      const data = await response.json();

      if (response.ok) {
        showAlert(data.success)
        setShowSpecQuotaModal(false)
        fetchData()
        // handleAssignationAutomatique()
      } else {
        showAlertModal(data.error, 'danger')
      }

    } catch (error) {
      console.error("Erreur lors de la réservation:", error);
      showAlert("Une erreur s'est produite lors de la réservation", "danger");
    }
    // finally {
    //   setShowSpecQuotaModal(false)
    // }
  };


  const calculateTotalQuotasRestant = (fret) => {
    let total = 0;

    // Vérifier si les quotas_restants existent
    if (!fret.quotas_restants) return 0;

    // Somme des quotas nationaux restants
    if (fret.quotas_restants.nationaux) {
      total += Object.values(fret.quotas_restants.nationaux)
        .reduce((sum, quota) => sum + (quota.valeur || 0), 0);
    }

    // Somme des quotas internationaux restants
    if (fret.quotas_restants.pays_destination) {
      total += Object.values(fret.quotas_restants.pays_destination)
        .reduce((sum, quota) => sum + (quota.valeur || 0), 0);
    }

    // Somme des quotas bailleur restants
    if (fret.quotas_restants.bailleur) {
      total += Object.values(fret.quotas_restants.bailleur)
        .reduce((sum, quota) => sum + (quota.valeur || 0), 0);
    }

    return total;
  };





  const handleTransactionMinimum = async (paymentResponse = null, camion_id) => {
    if (!camion_id) return;

    // setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/transaction-minimum-obligatoire/${camion_id}/${user_id}/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: paymentResponse ? JSON.stringify({
            payment_data: paymentResponse,
            reference: paymentResponse.reference
          }) : null,
        }
      );

      const data = await response.json();
      if (response.ok) {
        setShowDetailsModal(false);
        fetchData();
        showAlert(data.message)
      } else {
        showAlert(data.error, "danger");
      }
    } catch (error) {
      console.error("Erreur lors du paiement:", error);
      showAlert("Une erreur s'est produite lors du paiement", "danger");
    } finally {
      setShowDetailsModal(false);
      fetchData();
    }
  };


  // États nécessaires
  const [searchTermCamion, setSearchTermCamion] = useState('');
  const [currentPageCamion, setCurrentPageCamion] = useState(1);
  const [itemsPerPageCamion] = useState(10);
  const [sortConfigCamion, setSortConfigCamion] = useState({
    key: null,
    direction: 'asc',
  });

  // Fonction de tri
  const handleSortCamion = (key) => {
    let direction = 'asc';
    if (sortConfigCamion.key === key && sortConfigCamion.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfigCamion({ key, direction });
  };

  // Fonction de filtrage et tri
  const filteredCamions = useMemo(() => {
    let result = selectedFretDetails?.camions_assignes || [];

    // Filtrage par recherche
    if (searchTermCamion) {
      const term = searchTermCamion.toLowerCase();
      result = result.filter(camion =>
        camion.immatriculation.toLowerCase().includes(term) ||
        (camion.type_camion && camion.type_camion.toLowerCase().includes(term)) ||
        (camion.conducteur && camion.conducteur.toLowerCase().includes(term)) ||
        camion.charge_utile.toString().includes(term) ||
        (camion.categorie && camion.categorie.toLowerCase().includes(term)) ||
        camion.statut.toLowerCase().includes(term)
      );
    }

    // Tri
    if (sortConfigCamion.key) {
      result.sort((a, b) => {
        if (a[sortConfigCamion.key] < b[sortConfigCamion.key]) {
          return sortConfigCamion.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfigCamion.key] > b[sortConfigCamion.key]) {
          return sortConfigCamion.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    console.log(result)
    return result;
  }, [selectedFretDetails, searchTermCamion, sortConfigCamion]);

  const [showGlossary, setShowGlossary] = useState(false);



  const [accesGroupes, setAccesGroupes] = useState([]);
  const [groupeId, setGroupeId] = useState(null);
  const groupe = localStorage.getItem('groupe_id');

  const verifGroupe = async () => {
    const groupeStored = localStorage.getItem('groupe_id');
    const accesGroupeStored = localStorage.getItem('accesGroupe');

    if (groupeStored && accesGroupeStored) {
      setGroupeId(groupeStored);
      setAccesGroupes(JSON.parse(accesGroupeStored));
    } else {
      try {
        const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
        if (response.status === 200) {
          const data = response.data;
          setGroupeId(data.groupe);

          let cleanedAccessArray = [];
          if (Array.isArray(data.acces)) {
            cleanedAccessArray = data.acces.map((item) =>
              item.acces
                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                : []
            ).flat();

            setAccesGroupes(cleanedAccessArray);
          }

          localStorage.setItem('groupe', data.groupe);
          localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
        }
      } catch (error) {
        // console.error('Erreur lors de la vérification du groupe', error);
      }
    }
  };

  useEffect(() => {
    if (user_id) {
      verifGroupe();
    }
  }, [user_id]);

  if (!accesGroupes.includes("Fret")) {
    return (
      <Pas_acces />
    );
  }

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <FaBoxes size={25} className="mr-2" />
                  Frets déclarés sur {parcs.find(p => p.ref_parc === userData?.parc)?.nom_parc || parcs.find(p => p.ref_parc === parcRef)?.nom_parc || '....'}
                  {/* <span
                    className="ml-3 toggle-icon"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowInfo(!showInfo)}
                  >
                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                  </span> */}
                </div>

                {/* Bouton d'aide complètement à droite */}
                {/* <button
                  className="btn btn-link p-0 ml-2"
                  title="Manuel d'utilisation"
                  onClick={() => navigate('/Manuel-utilisation', {
                    state: {
                      fromModule: 'gestion-tours',
                      fromSection: 'gestion-frets'
                    }
                  })}
                >
                  <FaQuestionCircle size={18} />
                </button> */}
                <button
                  className="btn btn-link p-0 ml-2"
                  title="Aide"
                  onClick={() => setShowGlossary(true)}
                >
                  <FaQuestionCircle size={18} />
                </button>
              </h2>
              {/* <div className={`info-box p-0 col-lg-6 ${showInfo ? "open" : ""}`}>
                <small>
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th><span className="badge badge-secondary">En attente réservation</span></th>
                        <th><span className="badge badge-warning">En attente assignation</span></th>
                        <th><span className="badge bg-success">Assignation en cours</span></th>
                        <th><span className="badge bg-primary">Assignation terminée</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Le fret est déclaré mais pas encore réservé.</td>
                        <td>Réservation effectuée, en attente d'assignation des camions.</td>
                        <td>Certains camions sont assignés, mais pas tous.</td>
                        <td>Tous les camions nécessaires ont été assignés.</td>
                      </tr>
                    </tbody>
                  </table>

                </small>
              </div> */}
              {/* <small>Liste des déclarations de fret.</small> */}

              <small id="hbreadcrumb" className="d-flex justify-content-end">
                <ol className="breadcrumb custom-breadcrumb">
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    <Link to={`/Menu`}> Accueil</Link>
                  </li>

                  {parcRef && (
                    <li className="breadcrumb-item custom-breadcrumb-item active">
                      <Link to={`/Parcs`}>Mise en file</Link>
                    </li>
                  )}
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    Frets sur {parcs.find(p => p.ref_parc === userData?.parc)?.nom_parc || parcs.find(p => p.ref_parc === parcRef)?.nom_parc || '....'}
                  </li>
                </ol>
              </small>
            </div>
          </div>

          {alert.message && (
            <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2`}>
              <div
                // Utilisation de dangerouslySetInnerHTML pour afficher le message HTML
                dangerouslySetInnerHTML={{ __html: alert.message }}
              />

              <span
                onClick={fermerNotif}
                style={{
                  position: 'absolute',
                  top: '0px',   // Ajustez l'espacement comme vous le souhaitez
                  right: '10px', // Ajustez l'espacement comme vous le souhaitez
                  cursor: 'pointer'
                }}
              >
                <i className='fa fa-close'></i>
              </span>
            </div>
          )}

          <div className="wrapper wrapper-content animated fadeInRight mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Liste des frets</h5>
              <div className="d-flex flex-column flex-md-row">
                <button
                  onClick={() => fetchFrets(true)}
                  className="btn btn-success mr-2 ms-0 mb-2 mb-md-0 ms-md-2"
                  disabled={loading}
                >
                  {loading ? 'Chargement...' : <><FaRedo className="mr-1" />Actualiser</>}
                </button>
                {/* <button
                  onClick={() => window.open("/liste-frets-ecran", "_blank", 'noopener,noreferrer')}
                  className="btn btn-success mr-2 ms-0 mb-2 mb-md-0 ms-md-2"
                >
                  <FaDesktop className="me-1" /> Ecran
                </button> */}
                {/* <Link
                  to="/Enregistrer-fret"
                  className="btn btn-success mr-2 ms-0 mb-2 mb-md-0 ms-md-2"
                  title="Enregistrer un fret"
                >
                  <FaPlus /> Déclarer fret
                </Link> */}
                <button
                  // onClick={() => window.open("/liste-frets-ecran", "_blank", 'noopener,noreferrer')}
                  onClick={() => {
                    if (userData?.parc && userData.parc !== "Non affecté") {
                      window.open(
                        `/ecrans/${userData.parc}/liste-frets-ecran`,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    } else {
                      window.open(
                        "/Ecrans",
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }
                  }}
                  className="btn btn-success mr-2 ms-0 mb-2 mb-md-0 ms-md-2"
                >
                  <FaDesktop className="me-1" /> Ecran
                </button>
              </div>
            </div>
            <div className="ibox-content">

              {/* Barre de recherche et sélection d'éléments par page */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="me-2">
                  <select
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                    className="form-select bg-default p-1"
                    style={{
                      width: "auto",
                      border: "1px black solid",
                      borderRadius: "5px",
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                </div>
                <input
                  type="text"
                  placeholder="Rechercher..."
                  className="form-control"
                  style={{ maxWidth: "150px", width: "100%" }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {/* Tableauuuuuuuuuuuuuuuuuuuuuuuuuuuuuu */}
              <div className="">
                <table
                  className="footable table table-stripped footable-loaded tablet breakpoint"
                  data-page-size={itemsPerPage}
                >
                  <thead>
                    <tr>
                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('date_creation')}>
                        Date de déclaration
                        {sortConfig.key === 'date_creation'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>
                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('ref')}>
                        Ref
                        {sortConfig.key === 'ref'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>
                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('parc')}>
                        Parc
                        {sortConfig.key === 'parc'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>
                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('type_fret')}>
                        Type fret
                        {sortConfig.key === 'type_fret'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>

                      {/* <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('designation')}>
                        Désignation
                        {sortConfig.key === 'designation'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th> */}

                      {/* <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('nature')}>
                        Nature
                        {sortConfig.key === 'nature'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>

                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('conteneurise')}>
                        Conteneurisé
                        {sortConfig.key === 'conteneurise'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th> */}

                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('nom_bailleur')}>
                        Bailleur
                        {sortConfig.key === 'nom_bailleur'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>

                      <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('destinataire')}>
                        Destinataire
                        {sortConfig.key === 'destinataire'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>

                      <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('trajet')}>
                        Trajet
                        {sortConfig.key === 'trajet'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>

                      {/* <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('date_depart')}>
                        Date départ
                        {sortConfig.key === 'date_depart'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th>
                      <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('date_arrivee')}>
                        Date arrivée
                        {sortConfig.key === 'date_arrivee'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th> */}

                      {/* <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('statut')}>
                        Etape
                        {sortConfig.key === 'statut'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                      </th> */}
                      {userData.type_compte !== 'bailleur' && (
                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('total_quotas')}>
                          Ajouté par
                          {sortConfig.key === 'total_quotas'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                        </th>
                      )}

                      {/* <th className="text-center">Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {loading && currentPage === 1 ? (
                      <tr>
                        <td colSpan="10" className="text-center">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden"></span>
                          </div>
                        </td>
                      </tr>
                    ) : fretsTries.length > 0 ? (
                      fretsTries.map((fret) => (
                        <tr key={fret?.id}>
                          <td className="text-justify">
                            {/* {formatDate(fret.date_creation)} */}
                            {new Date(fret.date_creation).toLocaleDateString()}
                          </td>
                          <td className="text-justify">
                            {fret?.ref}
                          </td>
                          <td className="d-none d-md-table-cell text-justify">
                            {parcs.find(p => p.ref_parc === fret.parc_ref)?.nom_parc || 'Non spécifié'}
                            {/* {fret?.parc} */}
                          </td>
                          <td className="d-none d-md-table-cell text-justify">
                            {fret?.type_fret}
                          </td>
                          <td className="d-none d-md-table-cell text-justify">
                            {fret?.bailleur}
                          </td>
                          <td className="d-none d-md-table-cell text-center">{fret?.nom_destinataire}</td>
                          <td className="d-none d-md-table-cell text-center">
                            <small>
                              {/* <FaMapMarkerAlt />  */}
                              {fret?.ville_depart}
                              <FaArrowRight className="mx-2" />
                              {fret?.ville_arrivee}
                            </small>
                          </td>
                          {/* <td className="d-none d-md-table-cell text-justify">{new Date(fret?.date_depart).toLocaleDateString()}</td>
                          <td className="d-none d-md-table-cell text-justify">{new Date(fret?.date_arrivee).toLocaleDateString()}</td> */}
                          {/* <td className="d-none d-md-table-cell text-center">
                            {fret?.statut === 'en attente' && (
                              <span className="badge badge-secondary">En attente réservation</span>
                            )}
                            {fret?.statut === 'reservee' && (
                              <span className="badge badge-warning">En attente assignation</span>
                            )}
                            {fret?.statut === 'En cours' && (
                              <span className="badge bg-success">Assignation en cours</span>
                            )}
                            {fret?.statut === 'selection terminee' && (
                              <span className="badge bg-primary">Assignation terminée</span>
                            )}
                          </td> */}
                          {userData.type_compte !== 'bailleur' && (
                            <td className="d-none d-md-table-cell text-center">
                              {/* {fret?.utilisateur?.nom} {fret?.utilisateur?.prenoms} */}
                              SYGFR
                            </td>
                          )}
                          <td>
                            <Dropdown>
                              <Dropdown.Toggle variant="light" id={`dropdown-fret-${fret.id}`} className="p-0 pr-1 pl-1">
                                <i className="fa fa-ellipsis-v text-dark"></i>
                              </Dropdown.Toggle>

                              <Dropdown.Menu className="p-1">

                                {/* Option Détails - toujours visible */}
                                <Dropdown.Item
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleShowDetails(fret);
                                  }}
                                  className="d-flex align-items-center"
                                >
                                  <FaSearch className="mr-2 text-info" />
                                  Détails
                                </Dropdown.Item>

                                <div style={{ borderTop: '1px solid #eee' }} />

                                {fret?.statut != 'selection terminee' && (
                                  <Dropdown.Item
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setFretToDelete(fret);
                                      setShowDeleteModal(true);
                                      setOpenDropdownId(null);
                                    }}
                                    className="d-flex align-items-center"
                                  >
                                    <FaTrash className="mr-2 text-danger" />
                                    Corbeille
                                  </Dropdown.Item>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>

                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="11" className="text-center text-muted">
                          Aucun fret à afficher
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="dataTables_info" role="status" aria-live="polite">
                    {loading ? (
                      "Chargement..."
                    ) : fretsFiltres.length === 0 ? (
                      "Aucun élément à afficher"
                    ) : (
                      `Élément ${(currentPage - 1) * itemsPerPage + 1} à ${Math.min(currentPage * itemsPerPage, totalItems)
                      } sur ${totalItems}`
                      //   `Élément ${indexOfFirstItem + 1} à ${Math.min(indexOfLastItem, fretsFiltres.length)} 
                      // sur ${fretsFiltres.length}`
                    )}
                  </div>

                  {totalItems > itemsPerPage && (
                    <div>
                      <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="btn btn-light mx-1"
                      >
                        <FaArrowLeft />
                      </button>

                      {Array.from(
                        { length: Math.ceil(totalItems / itemsPerPage) },
                        (_, i) => i + 1
                      )
                        .filter(page =>
                          page === 1 ||
                          page === Math.ceil(totalItems / itemsPerPage) ||
                          Math.abs(page - currentPage) <= 2
                        )
                        .map((page, i, array) => (
                          <React.Fragment key={page}>
                            <button
                              onClick={() => setCurrentPage(page)}
                              className={`btn ${currentPage === page ? "btn-default" : "btn-light"
                                } mx-1`}
                            >
                              {page}
                            </button>
                            {array[i + 1] > page + 1 && <span className="mx-1">...</span>}
                          </React.Fragment>
                        ))}

                      <button
                        onClick={() => setCurrentPage(prev => prev + 1)}
                        disabled={currentPage >= Math.ceil(totalItems / itemsPerPage)}
                        className="btn btn-light mx-1"
                      >
                        <FaArrowRight />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal de confirmation de suppression */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header>
            <Modal.Title>Confirmer la suppression</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Êtes-vous sûr de vouloir supprimer ce fret ? Cette action est irréversible.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Annuler
            </Button>
            <Button variant="success" onClick={handleDeleteFret}>
              Confirmer la suppression
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal d'autorisation pour les quotas bailleurs */}
        <Modal show={showAuthorizationModal} onHide={() => setShowAuthorizationModal(false)}>
          <Modal.Header>
            <Modal.Title>Completer l'écran du bailleur</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <div dangerouslySetInnerHTML={{ __html: authoriserMessage }} /> */}
            <div className="">
              {/* <Form.Check
                type="radio"
                id="autoriser-oui"
                label="Oui"
                name="autorisation"
                checked={autorisationChoix === 'oui'}
                onChange={() => setAutorisationChoix('oui')}
              />
              <Form.Check
                type="radio"
                id="autoriser-non"
                label="Non"
                name="autorisation"
                checked={autorisationChoix === 'non'}
                onChange={() => setAutorisationChoix('non')}
              /> */}

              {/* Sélection conditionnelle */}
              {autorisationChoix === 'oui' && (
                <div className="mt-3" style={{ borderLeft: '2px solid #eee' }}>
                  <Form.Label>Source d'approvisionnement</Form.Label>
                  <Form.Select
                    className="form-control"
                    value={sourceApprovisionnement}
                    onChange={(e) => setSourceApprovisionnement(e.target.value)}
                  >
                    <option value="nationaux">Depuis Nationaux</option>
                    <option value="pays_destination">Depuis Internationaux</option>
                    <option value="les_deux">Les deux</option>
                  </Form.Select>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAuthorizationModal(false)}>
              Annuler
            </Button>
            <Button variant="success" onClick={confirmAuthorization}>
              Confirmer
            </Button>
          </Modal.Footer>
        </Modal>


        {/* Modal de confirmation pour l'assignation */}
        <Modal show={showAssignModal} onHide={() => setShowAssignModal(false)}>
          <Modal.Header>
            <Modal.Title>Confirmer l'assignation <span> {selectedFretDetails?.ref} </span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Êtes-vous sûr de vouloir assigner des camions à ce fret ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAssignModal(false)}>
              Annuler
            </Button>
            <Button
              variant="success"
              onClick={async () => {
                await assignerCamionsAuFret(fretToAssign.id);
                setShowAssignModal(false);
              }}
            >
              Confirmer l'assignation
            </Button>
          </Modal.Footer>
        </Modal>




        {/* Modal de détails */}
        <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} size="xl">
          <Modal.Header>
            <Modal.Title>Détails du fret - <span> {selectedFretDetails?.ref} </span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedFretDetails && (
              <div className="row">
                {/* Informations principales */}
                <div className="col-12 mb-4">
                  <div className="card">
                    <div className="card-header bg-info text-white">
                      <h5 className="mb-0 d-flex align-items-center">
                        <FaInfoCircle className="me-2 mr-2" />
                        Informations principales
                      </h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <p><strong>Référence:</strong> {selectedFretDetails.ref}</p>
                          <p><strong>Type de fret:</strong> {selectedFretDetails.type_fret}</p>
                          <p><strong>Bailleur:</strong> {selectedFretDetails.bailleur}</p>
                          <p><strong>IFU Bailleur:</strong> {selectedFretDetails.bailleur_ifu}</p>
                        </div>

                        <div className="col-md-4">
                          <p><strong>Destinataire:</strong> {selectedFretDetails.nom_destinataire}</p>
                          <p><strong>Date de déclaration:</strong> {new Date(selectedFretDetails.date_creation).toLocaleString()}</p>
                          <p><strong>Catégorie:</strong> {selectedFretDetails.categorie}</p>
                          <p><strong>Statut:</strong>
                            {selectedFretDetails.statut === 'selection terminee' && 'Assignation terminée'}
                            {selectedFretDetails.statut === 'En cours' && 'En cours de sélection'}
                            {selectedFretDetails.statut === 'en attente' && 'En attente de réservation'}
                            {selectedFretDetails.statut === 'reservee' && 'En attente assignation'}
                          </p>
                        </div>

                        <div className="col-md-4">
                          <p><strong>Départ:</strong> {selectedFretDetails.ville_depart}, {selectedFretDetails.pays_depart}</p>
                          <p><strong>Arrivée:</strong> {selectedFretDetails.ville_arrivee}, {selectedFretDetails.pays_arrivee}</p>
                          <p><strong>Date départ prévue:</strong> {new Date(selectedFretDetails.date_depart).toLocaleString()}</p>
                          <p><strong>Date arrivée prévue:</strong> {new Date(selectedFretDetails.date_arrivee).toLocaleString()}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Section Lots */}
                <div className="col-12 mb-4">
                  <div className="card">
                    <div className="card-header bg-primary text-white">
                      <h5 className="mb-0 d-flex align-items-center">
                        <FaBoxes className="me-2 mr-2" />
                        Lots ({selectedFretDetails.lots?.length || 0})
                      </h5>
                    </div>
                    <div className="card-body">
                      {selectedFretDetails.lots && selectedFretDetails.lots.length > 0 ? (
                        <Accordion defaultActiveKey={selectedFretDetails.lots.map((_, i) => i.toString())} alwaysOpen>
                          {selectedFretDetails.lots.map((lot, index) => (
                            <Accordion.Item eventKey={index.toString()} key={lot.id}>
                              <Accordion.Header as="div" className="bg-light mb-3">
                                <div className="d-flex justify-content-between align-items-center w-100">
                                  <span className="fw-bold text-dark">
                                    📦 Lot : {lot.reference} {lot.date_creation && `(${new Date(lot.date_creation).toLocaleDateString()})`} {lot.nationalite && ` — ${lot.nationalite}`}
                                  </span>
                                </div>
                              </Accordion.Header>
                              <Accordion.Body>
                                {/* Containers du lot */}
                                {lot.containers && lot.containers.length > 0 && (
                                  <div className="mb-3">
                                    <h6>Containers ({lot.containers.length})</h6>
                                    <table className="table table-sm table-bordered">
                                      <thead>
                                        <tr>
                                          <th>Référence</th>
                                          <th>Référence CSC</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {lot.containers.map(container => (
                                          <tr key={container.id}>
                                            <td>{container.reference}</td>
                                            <td>{container.csc_reference}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                )}

                                {/* Marchandises du lot */}
                                {lot.marchandises && lot.marchandises.length > 0 && (
                                  <div>
                                    <h6>Marchandises ({lot.marchandises.length})</h6>
                                    <table className="table table-sm table-bordered">
                                      <thead>
                                        <tr>
                                          <th>Référence</th>
                                          <th>Nom</th>
                                          <th>Poids</th>
                                          <th>Quantité</th>
                                          <th>Volume</th>
                                          <th>Valeur</th>
                                          <th>Position tarifaire</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {lot.marchandises.map(marchandise => (
                                          <tr key={marchandise.id}>
                                            <td>{marchandise.reference}</td>
                                            <td>{marchandise.nom}</td>
                                            <td>{marchandise.poids} {marchandise.unite_poids}</td>
                                            <td>{marchandise.quantite} {marchandise.unite_quantite}</td>
                                            <td>{marchandise.volume} {marchandise.unite_volume}</td>
                                            <td>{marchandise.valeur} {marchandise.devise}</td>
                                            <td>{marchandise.position_tarifaire}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                )}

                                {(!lot.containers || lot.containers.length === 0) &&
                                  (!lot.marchandises || lot.marchandises.length === 0) && (
                                    <p className="text-muted">Aucun détail disponible pour ce lot</p>
                                  )}
                              </Accordion.Body>
                            </Accordion.Item>
                          ))}
                        </Accordion>
                      ) : (
                        <div className="alert alert-warning mb-0">
                          <FaExclamationCircle className="me-2 mr-2" />
                          Aucun lot disponible pour ce fret
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
              Fermer
            </Button>
          </Modal.Footer>
        </Modal>




        {/* Modal combiné Spécificités et Quotas */}
        <Modal show={showSpecQuotaModal} onHide={() => setShowSpecQuotaModal(false)} size="xl">
          <Modal.Header>
            <Modal.Title>
              <FaTruck style={{ marginRight: '10px' }} />
              Réservation de transport - <span> {fretSelectionne?.ref} </span>
            </Modal.Title>
          </Modal.Header>

          {alertModal.message && (
            <div
              className={`alert alert-${alertModal.type} row justify-content-between position-relative m-3`}
            >
              <div
                dangerouslySetInnerHTML={{ __html: alertModal.message }}
              />
              <span onClick={fermerNotif} style={{ cursor: "pointer" }}>
                <i className="fa fa-close"></i>
              </span>
            </div>
          )}
          <Modal.Body>
            {/* Navigation par onglets */}
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'spec' ? 'active' : ''}`}
                  onClick={() => setActiveTab('spec')}
                >
                  Spécificités
                </button>
              </li>
              {fretSelectionne?.type_fret !== 'national' &&
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'quota' ? 'active' : ''}`}
                    onClick={() => setActiveTab('quota')}
                    disabled={formData.types_camions.length === 0}
                  >
                    Quotas
                  </button>
                </li>
              }

            </ul>

            {/* Contenu des onglets */}
            <div className="tab-content mt-3">
              {/* Onglet Spécificités */}
              <div className={`tab-pane wrapper wrapper-content animated fadeInDown fade ${activeTab === 'spec' ? 'show active' : ''}`}>
                <div>
                  <label> <strong>Types de camion appropriés</strong> </label>
                  <Select
                    isMulti
                    options={typesCamions}
                    value={typesCamions.filter(option =>
                      formData.types_camions.includes(option.value))
                    }
                    onChange={handleTypesCamionsChange}
                    placeholder="Sélectionnez un ou plusieurs types..."
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>

                {formData.types_camions.length > 0 && (
                  <div className="mt-3">
                    <label><strong>Détails par type de camion</strong></label>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: formData.types_camions.length === 1
                        ? 'minmax(300px, 500px)'
                        : 'repeat(auto-fit, minmax(300px, 1fr))',
                      gap: '15px',
                      marginTop: '10px',
                      justifyContent: formData.types_camions.length === 1 ? '' : 'normal'
                    }}>
                      {formData.types_camions.map(typeId => {
                        const typeLabel = typesCamions.find(t => t.value === typeId)?.label || typeId;
                        return (
                          <div key={`spec-${typeId}`} className="card p-3">
                            <h6>{typeLabel}</h6>
                            <div className="d-flex justify-content-between">
                              <div className="mt-2">
                                <label>Nombre de camions</label>
                                <input
                                  type="number"
                                  value={formData.nbre_type[typeId] || ''}
                                  onChange={(e) => handleNbreTypeChange(typeId, e.target.value)}
                                  min="0"
                                  className="form-control"
                                />
                              </div>
                              <div className="mt-2">
                                <label>Charge utile par camion</label>
                                <input
                                  type="number"
                                  value={formData.charge_utile_par_type[typeId] || ''}
                                  onChange={(e) => handleChargeUtileChange(typeId, e.target.value)}
                                  min="0"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              {/* Onglet Quotas */}
              <div className={`tab-pane wrapper wrapper-content animated fadeInDown fade ${activeTab === 'quota' ? 'show active' : ''}`}>
                {formData.types_camions.length > 0 ? (
                  <div className="row">
                    {formData.types_camions.map(typeId => {
                      const typeLabel = typesCamions.find(t => t.value === typeId)?.label || typeId;
                      return (
                        <div key={`quota-${typeId}`} className="col-md-6 mb-4">
                          <div className="card h-100">
                            <div className="card-header bg-primary text-white d-flex justify-content-between">
                              <div>{typeLabel}</div>

                              <small>
                                <strong>Total camions:</strong> {formData.nbre_type[typeId] || 0}<br />
                                {/* <strong>Charge utile:</strong> {formData.charge_utile_par_type[typeId] || 0} */}
                              </small>
                            </div>
                            <div className="card-body d-flex justify-content-between">
                              <div className="mb-3">
                                <label>Quotas nationaux</label>
                                <input
                                  type="number"
                                  value={formData.quota_nationaux[typeId] || ''}
                                  onChange={(e) => handleQuotaChange('quota_nationaux', typeId, e.target.value)}
                                  min="0"
                                  className="form-control"
                                />
                              </div>

                              <div className="mb-3">
                                <label>Quotas internationaux</label>
                                <input
                                  type="number"
                                  value={formData.quota_pays_destination[typeId] || ''}
                                  onChange={(e) => handleQuotaChange('quota_pays_destination', typeId, e.target.value)}
                                  min="0"
                                  className="form-control"
                                />
                              </div>

                              {/* <div className="mb-3">
                                <label>Quotas bailleur</label>
                                <input
                                  type="number"
                                  value={formData.quota_bailleur[typeId] || ''}
                                  onChange={(e) => handleQuotaChange('quota_bailleur', typeId, e.target.value)}
                                  min="0"
                                  className="form-control"
                                />
                              </div> */}

                              {/* <div className="alert alert-info">
                                <small>
                                  <strong>Total camions:</strong> {formData.nbre_type[typeId] || ''}<br />
                                  <strong>Charge utile:</strong> {formData.charge_utile_par_type[typeId] || ''}
                                </small>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="alert alert-warning">
                    Veuillez d'abord sélectionner des types de camions dans l'onglet Spécificités
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowSpecQuotaModal(false)}>
              Fermer
            </Button>

            {activeTab === 'quota' ? (
              <Button variant="success" onClick={() => setActiveTab('spec')}>
                <FaArrowLeft className="mr-2" />
                Précédent
              </Button>
            ) : (
              fretSelectionne?.type_fret !== 'national' && (
                <Button
                  variant="success"
                  onClick={() => setActiveTab('quota')}
                  disabled={formData.types_camions.length === 0}
                >
                  Suivant
                  <FaArrowRight className="ml-2" />
                </Button>
              )
            )}

            {/* Bouton Enregistrer conditionnel */}
            {(activeTab === 'quota' || fretSelectionne?.type_fret === 'national') && (
              <OverlayTrigger
                overlay={<Tooltip id="tooltip-disabled"></Tooltip>}
                placement="top"
              >
                <span className="d-inline-block">
                  <Button
                    variant="primary"
                    onClick={reserverTransport}
                    disabled={fretSelectionne?.statut === 'selection terminee' ||
                      (fretSelectionne?.type_fret !== 'national' &&
                        activeTab !== 'quota')}
                    style={
                      fretSelectionne?.statut === 'selection terminee' ||
                        (fretSelectionne?.type_fret !== 'national' && activeTab !== 'quota')
                        ? { pointerEvents: 'none' }
                        : {}
                    }
                  >
                    <FaSave className="mr-2" />
                    Enregistrer
                  </Button>
                </span>
              </OverlayTrigger>
            )}
          </Modal.Footer>
        </Modal>

        <div className="footer text-center">
          <div>
            <strong><a href="https://www.adnservicespro.com/" target="_blank" rel="noopener noreferrer">ADN Services</a></strong> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer">INOVACT SARL</a>
          </div>
        </div>
      </div>
      <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
    </div>
  );
};

export default Liste_declaration_fret;